<template>
  <div :class="{ 'edit-step': !isDarkMode, 'edit-step edit-step--dark': isDarkMode }">
    <div
      v-if="item"
      @click="select(skey)"
      :id="prefix + '-' + pos(skey)"
      class="d-flex step flex-wrap"
      :class="{
        'edit-step__inner-active--dark': isDarkMode && simulator && pos(skey) < cursorpos,
        'edit-step__inner-active': !isDarkMode && simulator && pos(skey) < cursorpos,
        active: pos(skey) === cursorpos,
      }"
    >
      <div
        class="edit-step__inner ma-0 d-flex align-center"
      >
        <apio-icon
          class="edit-step__drag-handle draghandle"
          v-if="prefix !== 'input' && pos(skey) === cursorpos"
          lightModeColour="white"
          darkModeColour="white"
          name="ui-drag"
        />
        <apio-icon
          class="edit-step__drag-handle draghandle"
          v-else-if="prefix !== 'input'"
          lightModeColour="apioshade2"
          darkModeColour="white"
          name="ui-drag"
        />
        <div v-else class="edit-step__empty-drag-space" />
        <div class="edit-step__icon" v-if="item.module" :title="item.module">
          <img
            :src="getIcon(item.module)"
            class="edit-step__image"
            :alt="item.module"
          />
        </div>
        <div
          class="edit-step__icon"
          v-if="!item.module"
          title="Select input type"
        >
          <v-icon large light color="red">mdi-alert</v-icon>
        </div>
        <div v-if="!item.module">
          <AddButton
            :prefix="prefix"
            :mkey="skey"
            :steps="steps"
            :inputs="inputs"
            :active="pos(skey) === cursorpos"
          />
        </div>

        <v-btn
          v-if="simulator"
          :id="`${prefix}-${skey}`"
          small
          icon
          class="mr-4 mt-1"
          @click.native="
            qstep = getSimPayload(prefix, skey - 1, 0);
            $set(modalKeys, pos(skey), true);
            selectedStep = item;
          "
        >
          <apio-icon v-if="pos(skey) === cursorpos" name="ui-play-pause" lightModeColour="white" darkModeColour="white" />
          <apio-icon v-else name="ui-play-pause" lightModeColour="black" darkModeColour="black" />
        </v-btn>

        <v-btn
          v-else-if="debug"
          :id="`${prefix}-${skey}`"
          small
          icon
          class="mr-4 mt-1"
          @click.native="playDebug(prefix, skey - 1, 0);"
        >
          <v-icon color="white" v-if="pos(skey) === cursorpos"
            >mdi-play-pause</v-icon
          >
          <v-icon v-else>mdi-play-pause</v-icon>
        </v-btn>

        <v-dialog
          max-width="600px"
          class="run-step"
          title="Run Step"
          v-model="modalKeys[pos(skey)]"
          :id="'modal-' + prefix + '-' + pos(skey)"
        >
          <v-card>
            <v-toolbar
              flat
              color="apioshade3"
              class="white--text run-step__toolbar"
            >
              <div class="white--text run-step__title">Run Step</div>
              <v-spacer></v-spacer>
              <apio-button
                button-type="get-started"
                button-size="small"
                @click="$set(modalKeys, pos(skey, false))"
                >Close
                <apio-icon
                  class="ml-2"
                  size="16"
                  name="cross"
                  lightModeColour="white"
                  darkModeColour="white"
              /></apio-button>
            </v-toolbar>
            <v-card-text class="mt-4">
              <p>Content</p>
              <v-textarea
                outlined
                v-if="prefix !== 'input'"
                style="color: red"
                v-model="qstep"
                @change="qstepChange"
              />
              <v-textarea outlined v-else style="color: red" v-model="extra" />
            </v-card-text>
            <v-card-actions class="pa-6">
              <v-spacer />
              <div class="step-modal__row text-right">
                <apio-button
                  v-if="prefix !== 'input'"
                  @click.native="
                    simStep(skey);
                    $set(modalKeys, pos(skey, false));
                  "
                  color="success"
                  >Run Step</apio-button
                >
                <apio-button
                  v-else
                  @click.native="
                    simStep(skey);
                    $set(modalKeys, pos(skey, false));
                  "
                  color="success"
                  >Run Step</apio-button
                >
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-text-field
          hide-details="auto"
          dense
          outlined
          :id="`list-${prefix}-${skey}`"
          :placeholder="stepPlaceholder"
          :disabled="item.module == undefined"
          v-model="item.shortname"
          autocomplete="off"
          type="text"
          title="Label"
        />
        <v-btn
          icon
          @click="$root.$emit('step-del', { prefix: prefix, key: skey })"
        >
          <span v-if="prefix === 'input'">
            <apio-icon
              v-if="pos(skey) === cursorpos"
              lightModeColour="white"
              darkModeColour="white"
              name="ui-trash"
            />
            <apio-icon
              v-else
              lightModeColour="black"
              darkModeColour="white"
              name="ui-trash"
            />
          </span>
          <span v-else>
            <v-menu bottom left offset-y nudge-left="12" nudge-top="8">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <apio-icon lightModeColour="white" darkModeColour="white" v-if="pos(skey) === cursorpos" name="ui-more-B"></apio-icon>
                  <apio-icon v-else name="ui-more-B"></apio-icon>
                </v-btn>
              </template>
              <div class="arrow_box">
                <v-list
                  class="edit-step__list"
                >
                  <div
                    class="edit-step__menu-item"
                    @click="moveUp(skey)"
                  >
                    Move up<apio-icon
                      name="chevron-up"
                      class="ml-4 edit-step__menu-item__icon"
                    />
                  </div>
                  <div
                    class="edit-step__menu-item"
                    @click="moveDown(skey)"
                  >
                    Move down<apio-icon
                      name="chevron-down"
                      class="ml-4 edit-step__menu-item__icon"
                    />
                  </div>
                   <div
                    class="edit-step__menu-item"
                    @click="editStep(skey)"
                  >
                    Edit<apio-icon
                      name="ui-edit"
                      class="ml-4 edit-step__menu-item__icon"
                    />
                  </div>
                  <hr class="mb-2">
                   <div
                    class="edit-step__menu-item"
                    @click="$root.$emit('step-del',{prefix: prefix, key: skey})"
                  >
                    Delete<apio-icon
                      name="ui-trash"
                      class="ml-4 edit-step__menu-item__icon"
                    />
                  </div>
                </v-list>
              </div>
            </v-menu>
          </span>
        </v-btn>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "EditStep",
  components: {
    AddButton: () => import("@/components/Editor/AddButton"),
  },
  props: [
    "item",
    "skey",
    "prefix",
    "cursorpos",
    "steps",
    "inputs",
    "simbundle",
    "variables",
    "simulator",
    "debug",
    "queues",
    "paused",
  ],
  data: () => ({
    selectedKey: "",
    extra: "",
    qstep: "",
    qitem: "",
    qindex: 0,
    qmodal: false,
    modal: false,
    selectedStep: {},
    modalKeys: {},
    qmodalKeys: {},
  }),
  computed: {
    ...mapState({
      datamapper: (state) => state.datamapper,
    }),
    isDarkMode() {
      return this.$store.state.mode.darkMode
    },
    v: {
      set: function (nv) {
        this.$emit("input", nv);
      },
      get: function () {
        return this.value;
      },
    },
    queuelink: function () {
      return typeof this.simbundle[this.prefix + ":" + this.skey] == "string";
    },
    stepPlaceholder: function() {
      return this.prefix === "input" ? "← Select input type from the dropdown" : "";
    },
  },
  methods: {
    qstepChange(v) {
      this.simbundle[this.selectedKey] = v;
    },
    moveUp(oldPos) {
      const newPos = oldPos - 1;
      this.$emit('moveUpOrDown', { oldPos, newPos })
      this.select(newPos);
    },
    moveDown(oldPos) {
      const newPos = oldPos + 1;
      this.$emit('moveUpOrDown', { oldPos, newPos })
      this.select(newPos);
    },
    pos(key) {
      return (this.prefix ? this.prefix + "." : "") + key;
    },
    getIcon(mod) {
      return (
        "/img/icons/" +
        (this.prefix === "input" ? "input" : "step") +
        "_" +
        mod +
        ".svg"
      );
    },
    getSimPayload(prefix, key, index) {
      if (prefix == "steps" && key == -1) {
        prefix = "input";
        key = -1;
      }
      if (this.simbundle[prefix + ":" + key] == undefined) {
        this.selectedKey = "";
        return null;
      }
      const qitem = this.simbundle[prefix + ":" + key][index].payload;
      this.$store.dispatch("updateQueueItem", JSON.parse(qitem));
      this.selectedKey = prefix + ":" + key;
      return qitem;
    },
    playDebug(prefix, key) {
      if (prefix == "steps" && key == -1) {
        prefix = "input";
        key = -1;
      }

      // if (this.simbundle[prefix + ":" + key] == undefined) {
      //   return null;
      // }

      this.$store.dispatch("playDebug", {
        appID: this.$route.query.a,
        interfaceID: this.$route.query.i,
      })
      // return qitem;
    },
    simStep(k) {
      this.$root.$emit("sim-step", {
        prefix: this.prefix,
        skey: this.skey,
        val: k,
        extra: this.extra,
        variables: this.variables,
        selectedStep: this.selectedStep,
      });
    },
    editStep(key) {
      this.$root.$emit('expand-step-details');
      this.select(key);
    },
    select(key) {
      this.$root.$emit("cursor-move", {
        pos: this.pos(key),
      });
    },
  },
};
</script>

<style lang="scss">
.step {
  border: 1px solid var(--apio-shade-4);
  // background: white;
  border-radius: 4px;
  min-height: 72px;

  @media screen and (max-width: 1024px) {
    margin-right: 0;
  }
}

.active {
  background: var(--apio-purple);
  color: white;

  @media screen and (min-width: 769px) {
    margin-right: -24px; //connect to the details pane
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.run-step {
  &__toolbar {
    background: var(--apio-shade-3);
    color: white;
  }
  &__title {
    font-size: var(--font-h2-size);
    font-weight: 600;
  }
}

.edit-step {
  background: white;
  .v-btn:not(.v-btn--round).v-size--default {
    padding: 0 8px 0 0;
    min-width: 32px;
    transition-property: width;
    transition-duration: 5s;
  }

  &--dark {
    background: var(--apio-shade-2);
  }

  &__list {
    border-radius: 4px;
    min-width: 150px;
    height: fit-content;
    width: fit-content;
    // background: #fff;
    padding: 6px 0 2px 0 !important;

    // border: 1px solid var(--apio-cyan) !important;
    box-shadow: none !important;

    &__dark {
      background: var(--apio-shade-2) !important;
      border: 1px solid #fff !important;
      color: white;
    }
  }
  &__menu-item {
    height: 26px !important;
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    line-height: 26px;
    font-size: 14px;
    font-weight: normal;
    padding: 0 4px 0 8px;
    cursor: pointer;

    &:hover {
      text-decoration: none !important;
      color: var(--apio-blue-black) !important;
      background: var(--apio-shade-5) !important;
    }

    &__dark {
      border: 1px solid #fff !important;
      background: #1e1e1e;
    }
  }
  &__inner-active {
    border: 1px solid var(--apio-purple);
    &--dark {
      background: var(--apio-purple);
    }
  }
  &__inner {
    width: 100%;
    border-radius: 4px;
    &--dark {
      // background: var(--apio-shade-2);
      color: white;
    }
  }
  &__drag-handle {
    margin: 0 4px;
    cursor: pointer;
  }
  &__empty-drag-space {
    width: 32px;
  }
  &__image {
    height: 40px;
    width: 40px;
  }
  &__icon {
    height: 48px;
    margin: 8px 8px 0 4px;
  }
}
</style>
